import ViewProductsHome from "../views/ViewProductsHome.vue"
import ViewProductsDetail from "../views/ViewProductsDetail.vue"
import ViewProductsDiscountsCodes from "../views/ViewProductsDiscountsCodes.vue"
import ViewProductsLoadingsCodes from "../views/ViewProductsLoadingsCodes.vue"
import ViewProductsBenefits from "../views/ViewProductsBenefits.vue"
import ViewProductsPricing from "../views/ViewProductsPricing.vue"
import ViewProductsUnderwriting from "../views/ViewProductsUnderwriting.vue"

export default [
	{
		path: "/products",
		component: ViewProductsHome,
		name: "ViewProductsHome",
		props: true,
		meta: {}
	},
	{
		path: "/products/detail/info/:productPlan/:productType/:productVersion?",
		component: ViewProductsDetail,
		name: "ViewProductsDetail",
		props: true,
		meta: {}
	},
	{
		path: "/products/detail/discountsCodes/:productPlan/:productType/:productVersion?",
		component: ViewProductsDiscountsCodes,
		name: "ViewProductsDiscountsCodes",
		props: true,
		meta: {}
	},
	{
		path: "/products/detail/loadingsCodes/:productPlan/:productType/:productVersion?",
		component: ViewProductsLoadingsCodes,
		name: "ViewProductsLoadingsCodes",
		props: true,
		meta: {}
	},
	{
		path: "/products/detail/benefits/:productPlan/:productType/:productVersion?",
		component: ViewProductsBenefits,
		name: "ViewProductsBenefits",
		props: true,
		meta: {}
	},
	{
		path: "/products/detail/pricing/:productPlan/:productType/:productVersion?",
		component: ViewProductsPricing,
		name: "ViewProductsPricing",
		props: true,
		meta: {}
	},
	{
		path: "/products/detail/underwriting/:productPlan/:productType/:productVersion?",
		component: ViewProductsUnderwriting,
		name: "ViewProductsUnderwriting",
		props: true,
		meta: {}
	}
]
